module.exports = __webpack_public_path__ + "img/1-5.15b6cd96.svg";